module.exports = __webpack_public_path__ + "img/5B5428_C5A052_A28B46_ADA752-256px.70031a9e.png";